const columnEmployee = [
  {
    title: "Code",
    dataIndex: "code",
    scopedSlots: { customRender: "code" },
    sorter: (employeeA, employeeB) => {
      var codeA = employeeA.code.toUpperCase();
      var codeB = employeeB.code.toUpperCase();
      if (codeA > codeB) {
        return -1;
      }
      if (codeA < codeB) {
        return 1;
      }
      return 0;
    },

    width: 120,
    sortDirections: ["descend"],
    fixed: "left",
  },
  {
    title: "Fullname",
    dataIndex: "fullname",
    scopedSlots: { customRender: "fullname" },
    sorter: (employeeA, employeeB) => {
      var fullnameA = employeeA.fullname.toUpperCase();
      var fullnameB = employeeB.fullname.toUpperCase();
      if (fullnameA > fullnameB) {
        return -1;
      }
      if (fullnameA < fullnameB) {
        return 1;
      }
      return 0;
    },
    width: 200,
    sortDirections: ["descend"],
  },
  {
    title: "Department",
    dataIndex: "department.name",
    scopedSlots: { customRender: "department" },
    width: 200,
  },
  {
    title: "Position",
    dataIndex: "position.name",
    scopedSlots: { customRender: "position" },
    width: 200,
  },
  {
    title: "Location",
    dataIndex: "branchLocation.name",
    scopedSlots: { customRender: "position" },
    width: 200,
  },
  {
    title: "Main shift",
    dataIndex: "workShift.title",
    scopedSlots: { customRender: "position" },
    width: 200,
  },
  {
    title: "Phone",
    dataIndex: "phone",
    width: 200,
  },
  {
    title: "Email",
    dataIndex: "email",
    scopedSlots: { customRender: "email" },
    ellipsis: true,
    width: 200,
  },
  {
    title: "Code Department",
    dataIndex: "codeDepartment",
    width: 200,
  },
  {
    title: "Cost Center",
    dataIndex: "costCenter",
    width: 200,
  },
  {
    title: "Started date",
    dataIndex: "startedDate",
    scopedSlots: { customRender: "startedDate" },
    width: 200,
  },

  {
    title: "Gender",
    dataIndex: "gender",
    scopedSlots: { customRender: "gender" },
    width: 100,
  },
  {
    title: "Birthday",
    dataIndex: "birthday",
    scopedSlots: { customRender: "birthday" },
    width: 100,
  },

  {
    title: "Account",
    dataIndex: "user.fullname",
    scopedSlots: { customRender: "user" },
    width: 150,
  },
  {
    title: "Annual leave",
    dataIkeyndex: "annualLeave",
    align: "center",
    children: [
      {
        title: "Original",
        dataIndex: "annualLeaveDay.original",
        scopedSlots: { customRender: "original" },
        align: "center",
        width: 150,
      },
      {
        title: "Default",
        dataIndex: "annualLeaveDay.default",
        scopedSlots: { customRender: "default" },
        align: "center",
        width: 150,
      },
      {
        title: "Used",
        dataIndex: "annualLeaveDay.usedInYear",
        scopedSlots: { customRender: "usedInYear" },
        align: "center",
        width: 150,
      },
      {
        title: "Remain",
        dataIndex: "annualLeaveDay.remain",
        scopedSlots: { customRender: "remain" },
        align: "center",
        width: 150,
      },
    ],
  },
  {
    title: "",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 150,
    fixed: "right",
  },
];

export { columnEmployee };
